module.exports = __webpack_public_path__ + "static/media/Android_sim.a00bf9f0.jpg";